module.exports = __webpack_public_path__ + "img/locate-vending-machine-footer-SM04.17fe95ab.png";